import { OrderOperationType, OrderStatusType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';

import { useOrderContext } from '../../../providers/OrderProvider';
import { OperationsTable } from '../../OperationsTable';
import { OrderSection } from '../../OrderSection';

const finishedStatuses = new Set([
  OrderStatusType.Cancelled,
  OrderStatusType.Executed,
  OrderStatusType.PartiallyExecuted,
  OrderStatusType.NotExecuted,
  OrderStatusType.Revoked,
]);

export const OperationsSection = () => {
  const { t } = useTranslation();

  const { order } = useOrderContext();

  if (!order) {
    return null;
  }

  const isPurchaseOrSale =
    order.operationType === OrderOperationType.SecuritiesPurchase ||
    order.operationType === OrderOperationType.SecuritiesSale;

  const isFinished = finishedStatuses.has(order.status);

  if (!isPurchaseOrSale || !isFinished) {
    return null;
  }

  return (
    <OrderSection
      afterContent={<OperationsTable />}
      fields={[]}
      title={t('account.order.sections.operationsSection.title')}
    />
  );
};
